import React, { Component } from 'react';

import Row from './Flex';
import Spacer from './Spacer';

import * as util from '../util';

export default class PricingTable extends Component {
  render() {
    if (!this.props.prices || this.props.prices.length === 0)
      return <small>Unknown.</small>;
    return (
      <div className="table">
        {this.props.prices.map((price, i) => {
          if (!util.exists(price.fee) || !util.exists(price.amount))
            return null;
          return (
            <Row justify="space-between" key={i}>
              <p style={{ flex: 1 }}>{price.fee}</p>
              <Spacer size="small" />
              <p style={{ flex: 1, textAlign: 'right' }}>
                <b>
                  {util.exists(price.amount) ? `$${price.amount}` : 'Unknown'}
                </b>
              </p>
            </Row>
          );
        })}
      </div>
    );
  }
}
